
'use strict'
module.exports = ( new ( require 'intertype' ).Intertype() ).export()
